import React from 'react';
import './App.css';
import Header from './components/Header/Header';
import Hero from './components/Hero/Hero';
import Contest from './components/Contest/Contest';
import Funding from './components/Funding/Funding';
import Column from './components/Column/Column';
import Footer from './components/Footer/Footer';
import { Routes, Route } from 'react-router-dom';
import ColumnPage from './components/ColumnPage/ColumnPage';

function App() {
  return (
    <div className="App">
      <Header />
      <main>
        <Routes>
          <Route path="/" element={
            <>
              <Hero />
              <Contest />
              <Funding />
              <Column />
            </>
          } />
          <Route path="/column/:slug" element={<ColumnPage />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;
